<template>
  <ul class="itemallocatefliter">
    <li v-for="(item, index) in filterlist" :key="index" :tabindex="index" :class="item.ActiveClass"
      @click="setActiveIndex(item)">
      {{ item.CategoryName }}
      <OrangeBadge :BadgeValue="item.count" />
    </li>
  </ul>
  <!-- {{ BarCodeItemList }} -->

  <NormalTable v-model:value="BarCodeItemList" :paginator="true" class="p-datatable-gridlines mt-5" :rows="10"
    dataKey="Id" :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
    :globalFilterFields="globalFilterFields" :filters="filters" :selectionMode="true" :exceldownload="true"
    v-model:selection="barcodeValues" @update:selection="onSelectionChange" :addnewbtn="true"
    @updatedata="Itemschanges">
    <template v-slot:ItemName="{ data }">
      {{ data.Itemname1 + " - " + data.BarCode }}
      <div v-if="data.DCItem == 1">
        <span class="DCItem">(DC)</span>
      </div>
      <div v-else-if="data.IsFreeItem == 1">
        <span class="PromoItem"> (Promo) </span>
      </div>
      <div v-else-if="data.IsFreeQtyItem == 1">
        <span class="FreeItem">(Free)</span>
      </div>
    </template>

    <!-- <template v-slot:qty="{ data }">
      <div class="label-d-none tablefield mb-0">
        <TextField type="text" placeholder="" clearable name="" id="$t('userManagement.branch.branchCode')" label=""
          v-model="data.Qty" :rules="{ required: false, numeric: true }" :requiredIcon="false" />
      </div>
     
    </template> -->
    <template v-slot:Add>
      <div class="mb-2">
        <AddButton btnname="Barcode Print" @click="printBarcodes()"></AddButton>
        <AddButton btnname="Print" @click="Printed(selectedItem)"></AddButton>
      </div>
    </template>
    <template v-slot:Room="{ data }">
      <div class="label-d-none tablefield mb-0">
        <CustomDropdown :items="data.RoomOption" v-model="data.RoomId" :disabled="data.DCItem == 1 ? true : false"
          @update:modelValue="getrackbyroomid(data)" :show-clear="false">
        </CustomDropdown>
      </div>
    </template>
    <template v-slot:Rack="{ data }">
      <div class="label-d-none tablefield mb-0">
        <CustomDropdown :items="data.RackOption" v-model="data.RackId" :disabled="data.DCItem == 1 ? true : false"
          @update:modelValue="getrowbyrackid(data)" :show-clear="false">
        </CustomDropdown>
      </div>
    </template>
    <template v-slot:Row="{ data }">
      <div class="label-d-none tablefield mb-0">
        <CustomDropdown :items="data.RowOption" v-model="data.RowId" :disabled="data.DCItem == 1 ? true : false"
          @update:modelValue="getboxbyrowid(data)" :show-clear="false">
        </CustomDropdown>
      </div>
    </template>
    <template v-slot:Box="{ data }">
      <div class="label-d-none tablefield mb-0">
        <CustomDropdown :items="data.BoxOption" v-model="data.BoxId" :disabled="data.DCItem == 1 ? true : false"
          @update:modelValue="getboxwithcapacity(data.BoxId, data)" :show-clear="false">
        </CustomDropdown>
      </div>
    </template>
    <template v-slot:ExpiryDate="{ data }">
      <div>
        <span :style="getExpiryDateStyle(data.ExpiryDate)">
          {{
            data.ExpiryDate === "01-01-1900" ||
              data.ExpiryDate === "01-01-0001" ||
              data.ExpiryDate === "-"
              ? ""
              : data.ExpiryDate
          }}
        </span>
        <div v-if="getExpiryMessage(data.ExpiryDate)" class="expiry-message">
          {{ getExpiryMessage(data.ExpiryDate) }}
        </div>
      </div>
    </template>
  </NormalTable>
  <div>
    <div v-for="(barcode, index) in barcodeValues" :key="index" class="barcode-container d-none">
      <svg :id="'barcode-' + index"></svg>
    </div>
  </div>
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, watch } from "vue";
import AddButton from "../../../../components/GeneralButtons/AddButton.vue";
import NormalTable from "../../../../components/FormComponents/NormalTable.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import { FilterMatchMode } from "primevue/api";
import { width } from "dom7";
import StockInService from "../../../../modules/Inventory/Service/StockInService";
import { AnyCnameRecord } from "dns";
import RackService from "../../../../modules/Inventory/Service/RackService";
import RowService from "../../../../modules/Inventory/Service/RowService";
import { useRoute, useRouter } from "vue-router";
import ItemStoreMappingService from "../../../../modules/Inventory/Service/ItemStoreMappingService";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import JsBarcode from "jsbarcode";
import moment from "moment";
import CrystalReportPrintPopUp from "../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";

export default defineComponent({
  components: {
    TextField,
    NormalTable,
    AddButton,
    CustomDropdown,
    CrystalReportPrintPopUp,
  },
  props: {
    GRNId: {
      type: Number,
      default: 0,
    },
    selectedList: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const BarCodeItem: any = ref([]);
    const BarCodeItemList: any = ref([]);
    const itemcatfilter = ref("");
    const itemcatfilteroptions = ref([]);
    const activeIndex = ref(0);
    const routes = useRoute();
    let StoreId = routes.query.StoreId ?? 0;
    const { t } = useI18n();
    const setActiveIndex = (item) => {
      debugger;
      if (item.CategoryId == 0) {
        BarCodeItemList.value = BarCodeItem.value;
        filterlist.value = filterlist.value.map((item) => {
          if (item.CategoryId != 0) {
            item.ActiveClass = "";
          } else {
            item.ActiveClass = "active";
          }
          return item;
        });
      } else {
        filterlist.value = filterlist.value.map((item) => {
          if (item.CategoryId == 0) {
            item.ActiveClass = "";
          }
          return item;
        });
        item.ActiveClass = item.ActiveClass == "active" ? "" : "active";
        let arr = filterlist.value
          .filter((item) => item.ActiveClass == "active")
          .map((it1) => it1.CategoryId);

        BarCodeItemList.value = [];
        BarCodeItemList.value = BarCodeItem.value.filter((item) =>
          arr.includes(item.CategoryId)
        );
      }
    };
    const selectedItem: any = ref([]);
    const toast = useToast();

    watch(
      () => props.selectedList,
      (newVal) => {
        selectedItem.value = newVal;
      }
    );
    const filterlist: any = ref([
      // { name: 'Pharmacy', badgeValue: 10 },
      // { name: 'Stationary', badgeValue: 10 },
      // { name: 'Laboratory', badgeValue: 10 },
      // { name: 'Electronics', badgeValue: 10 }
    ]);
    const headers = [
      {
        header: t("storetabdetails.grnitemallocatedlist.Item"),
        field: "ItemCode",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.grnitemallocatedlist.ItemName"),
        field: "itemname",
        slot: "ItemName",
        sortable: false,
        fieldDisplay: "false",

        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.BatchNo"),
        field: "BatchNo",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.Qty"),
        field: "Qty",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.FreeQty"),
        field: "FreeQty",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.ManufactureDate"),
        field: "ManufactureDate",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.ExpiryDate"),
        field: "ExpiryDate",
        slot: "ExpiryDate",
        class: "smallwidth",
        bodyclass: "right_td",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.Room"),
        field: "Room",
        slot: "Room",
        class: "mediumsmallwidth",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.Rack"),
        field: "Rack",
        slot: "Rack",
        sortable: false,
        class: "mediumsmallwidth",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.Row"),
        field: "Row",
        slot: "Row",
        sortable: false,
        class: "mediumsmallwidth",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.grnitemallocatedlist.Box"),
        field: "Box",
        slot: "Box",
        sortable: false,
        class: "mediumsmallwidth",
        fieldDisplay: "false",
      },
    ];
    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Item: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: BarCodeItem,
      },
      HSN: { value: null, matchMode: FilterMatchMode.IN, options: BarCodeItem },
      itemname: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: BarCodeItem,
      },
      Room: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: BarCodeItem,
      },
      Rack: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: BarCodeItem,
      },
      Row: { value: null, matchMode: FilterMatchMode.IN, options: BarCodeItem },
      Box: { value: null, matchMode: FilterMatchMode.IN, options: BarCodeItem },
    };
    const DataObj = ref({
      RoomOption: [],
      RackOption: [],
      RowOption: [],
      BoxOption: [],
    });
    /*--Functions--*/
    onMounted(async () => {
      debugger;
      await getroombystoreid();
      if (props.GRNId) {
        GetByGRNId();
      }
    });
    watch(
      () => BarCodeItem.value,
      (newVal) => {
        debugger;
        emit("BarCodeItem", newVal);
      }
    );

    //Get List By GRNId
    async function GetByGRNId() {
      try {
        debugger;
        let result = await StockInService.getlistById(props.GRNId);
        console.log(result);

        GetItemStoreMappingDetail(result["result"][0].HospitalId, result["result"][0].BranchId, result["result"][0].StoreId);

        BarCodeItemList.value = result["result"].map((i1) => {
          let i2: any = {};
          i2.StoreId = StoreId;
          (i2.CategoryId = i1.CategoryId),
            (i2.ItemId = i1.ItemId),
            (i2.BarCodeNo = i1.BarCodeNo),
            (i2.BarCode = i1.BarCode),
            (i2.RoomId = i1.RoomId),
            (i2.RackId = i1.RackId),
            (i2.RowId = i1.RowId),
            (i2.Qty = i1.IssuedQty),
            (i2.BoxId = i1.BoxId),
            (i2.StockInId = i1.RefId),
            (i2.StockInDetailsId = i1.StockDetailsId),
            (i2.CategoryName = i1.ItemCategory1),
            (i2.Itemname1 = i1.Itemname1),
            (i2.ItemCode = i1.ItemProductId),
            (i2.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (i2.RoomOption = DataObj.value.RoomOption),
            (i2.ItemQuantity = i1.ItemQuantity),
            (i2.BatchNo = i1.BatchNo),
            (i2.ExpiryDate =
              i1.ExpiryDate == "01-01-1900" ? "-" : i1.ExpiryDate),
            (i2.DCItem = i1.DCItem),
            (i2.ManufactureDate =
              i1.ManufactureDate == "01-01-1900" ? "-" : i1.ManufactureDate),
            (i2.IsFreeItem = i1.IsFreeItem),
            (i2.IsFreeQtyItem = i1.IsFreeQtyItem);
          return i2;
        });

        BarCodeItem.value = BarCodeItemList.value;

        filterlist.value = BarCodeItem.value.reduce((acc: any, current) => {
          const { CategoryId, CategoryName }: any = current;
          const existingCategory: any = acc.find(
            (item) => item["CategoryId"] == CategoryId
          );
          if (existingCategory) {
            existingCategory.count++;
          } else {
            acc.push({ CategoryId, CategoryName, count: 1, ActiveClass: "" });
          }
          return acc;
        }, []);
        filterlist.value.splice(0, 0, {
          CategoryId: 0,
          CategoryName: "All",
          count: BarCodeItemList.value.length,
          ActiveClass: "active",
        });
        emit("BarCodeItem", BarCodeItemList.value);

        for (let i = 0; i < BarCodeItemList.value.length; i++) {
          await getrackbyroomid(BarCodeItemList.value[i]);
          await getrowbyrackid(BarCodeItemList.value[i]);
          await getboxbyrowid(BarCodeItemList.value[i]);

          await BinLocationmapping(BarCodeItemList.value[i]);

        }
      } catch (error) { }
    }

    let ItemStoreMappingDetail: any = ref([]);

    async function GetItemStoreMappingDetail(HospitalId, BranchId, StoreId) {
      debugger;

      try {
        const dataresponse = await ItemStoreMappingService.GetItemStoreMappingDetail(
          HospitalId, BranchId, StoreId
        );

        ItemStoreMappingDetail.value = dataresponse["result"];

      }
      catch (error) {
        console.log(error);
      }
    }

    function BinLocationmapping(data) {
      debugger;
      // alert("RoomId" + data.RoomId);
      // alert("RackId" + data.RackId);
      // alert("RowId" + data.RowId);
      // alert("BoxId" + data.BoxId);
    }

    // get room name by store id
    async function getroombystoreid() {
      try {
        const dataresponse = await ItemStoreMappingService.getroommaster(
          StoreId
        );

        DataObj.value.RoomOption = dataresponse["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    // get rack name by room id

    async function getrackbyroomid(data) {
      debugger;
      try {
        const dataresponse = await RackService.getRackByRoomId(data.RoomId);

        data.RackOption = dataresponse["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    // get row name by rack name

    async function getrowbyrackid(data) {
      debugger;
      try {
        const dataresponse = await RowService.getRowByRackId(data.RackId);

        data.RowOption = dataresponse["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    // get box name by rowid

    async function getboxbyrowid(data) {
      debugger;
      try {
        const dataresponse = await ItemStoreMappingService.getboxmasterGRN(
          data.RowId
        );

        data.BoxOption = dataresponse["result"].map((item: any) => {
          item.name = item.BoxName;
          item.value = item.Id;
          item.BalanceCapacity = item.BalanceCapacity;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }
    interface Barcode {
      BarCode: string;
    }
    const barcodeValues = ref<Barcode[]>([]);

    const generateBarcodes = () => {
      setTimeout(() => {
        barcodeValues.value.forEach((barcode, index) => {
          JsBarcode("#barcode-" + index, barcode.BarCode, {
            format: "CODE128",
            displayValue: true,
          });
        });
      }, 600);
    };

    // const printBarcodes = () => {
    //   if (barcodeValues.value.length != 0) {
    //     const printWindow = window.open("", "PRINT", "height=400,width=600");
    //     if (printWindow) {
    //       printWindow.document.write(
    //         "<html><head><title>Print Barcodes</title></head><body>"
    //       );
    //       barcodeValues.value.forEach((_, index) => {
    //         const barcodeElement = document.getElementById("barcode-" + index);
    //         if (barcodeElement) {
    //           const svgData = new XMLSerializer().serializeToString(
    //             barcodeElement
    //           );
    //           printWindow.document.write(`<div>${svgData}</div>`);
    //         }
    //       });
    //       printWindow.document.write("</body></html>");
    //       printWindow.document.close();
    //       printWindow.focus();
    //       setTimeout(() => {
    //         printWindow.print();
    //         printWindow.close();
    //       }, 1000); // Added delay to ensure the content is fully loaded before printing
    //     }
    //   } else {
    //     toast.add({
    //       severity: "warn",
    //       summary: "Select the Items for Barcode Print",
    //       detail: "",
    //       life: 3000,
    //     });
    //   }
    // };

    const printBarcodes = () => {
      debugger;
      if (barcodeValues.value.length != 0) {
        const barcodenos = selectedItem.value
          .map((item) => item["BarCodeNo"])
          .join(",");

        CrystalReportPopup.value = true;
        ParameterValues.value.Id = barcodenos;
        PrintType.value.FormId = 107;
      } else {
        toast.add({
          severity: "warn",
          summary: "No Items Selected",
          detail: "Please select at least one item to print barcodes.",
          life: 3000,
        });
      }
    };

    const onSelectionChange = (event: any) => {
      debugger;

      // selectedItem.value = event.BarCode;
      selectedItem.value = event;

      generateBarcodes();
    };
    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: 0,
    });
    function Printed(ObjData) {
      debugger;
      CrystalReportPopup.value = true;
      PrintType.value.FormId = 2;

      // ParameterValues.value.Id = ObjData.value.Id;
      ParameterValues.value.Id = props.GRNId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    const PrintType = ref({
      Type: "T",
      FormId: 2,
      HeaderTitle: "Item barcode",
      ModuleId: 3,
    });
    async function getboxwithcapacity(BoxId, data) {
      debugger;
      if (BoxId) {
        let avlcap = data.BoxOption.find((item) => item.Id === BoxId);

        if (avlcap) {
          if (avlcap.BalanceCapacity <= data.ItemQuantity) {
            toast.add({
              severity: "warn",
              summary:
                "selected box capacity is " +
                avlcap.BalanceCapacity +
                ", cant fix this Item Qty",
              detail: "",
              life: 3000,
            });
            data.BoxId = "";
            // return false;
          } else {
          }
        } else {
        }
      }
    }
    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        BarCodeItemList.value = [];
        BarCodeItemList.value = value;
      }
    };

    function getExpiryDateStyle(expiryDate) {
      // Return empty style for invalid dates
      if (
        !expiryDate ||
        expiryDate === "01-01-0001" ||
        expiryDate === "01-01-1900" ||
        expiryDate === "-"
      ) {
        return {};
      }

      try {
        // Parse the date in DD-MM-YYYY format
        const dateParts = expiryDate.split("-");
        if (dateParts.length !== 3) {
          return {};
        }

        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date
        const year = parseInt(dateParts[2], 10);

        const expiry = new Date(year, month, day);
        const currentDate = new Date();

        // Calculate the difference in milliseconds
        const timeDifference = expiry.getTime() - currentDate.getTime();

        // Convert milliseconds to days
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        // If expiry date is within 90 days, return warning color
        if (daysDifference <= 90 && daysDifference >= 0) {
          return {
            color: "#ff9800", // Orange warning color
            fontWeight: "bold",
          };
        }

        // If already expired, return red color
        if (daysDifference < 0) {
          return {
            color: "red",
            fontWeight: "bold",
          };
        }

        return {}; // Default style for dates beyond 90 days
      } catch (error) {
        console.error("Error parsing expiry date:", error);
        return {};
      }
    }

    function getExpiryMessage(expiryDate) {
      // Return empty message for invalid dates
      if (
        !expiryDate ||
        expiryDate === "01-01-0001" ||
        expiryDate === "01-01-1900" ||
        expiryDate === "-"
      ) {
        return "";
      }

      try {
        // Parse the date in DD-MM-YYYY format
        const dateParts = expiryDate.split("-");
        if (dateParts.length !== 3) {
          return "";
        }

        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date
        const year = parseInt(dateParts[2], 10);

        const expiry = new Date(year, month, day);
        const currentDate = new Date();

        // Calculate the difference in milliseconds
        const timeDifference = expiry.getTime() - currentDate.getTime();

        // Convert milliseconds to days
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        // If expiry date is within 90 days, show message
        if (daysDifference <= 90 && daysDifference >= 0) {
          return `Expires in ${daysDifference} day${daysDifference === 1 ? "" : "s"
            }`;
        }

        // If already expired, show expired message
        if (daysDifference < 0) {
          const expiredDays = Math.abs(daysDifference);
          return `Expired ${expiredDays} day${expiredDays === 1 ? "" : "s"
            } ago`;
        }

        return ""; // No message for dates beyond 90 days
      } catch (error) {
        console.error("Error parsing expiry date:", error);
        return "";
      }
    }

    return {
      Itemschanges,
      Printed,
      PrintType,
      CrystalReportPopup,
      ParameterValues,
      hidepopup,
      onSelectionChange,
      barcodeValues,
      generateBarcodes,
      printBarcodes,
      selectedItem,
      getrackbyroomid,
      getrowbyrackid,
      getboxbyrowid,
      globalFilterFields,
      filters,
      headers,
      BarCodeItem,
      itemcatfilter,
      itemcatfilteroptions,
      activeIndex,
      setActiveIndex,
      filterlist,
      DataObj,
      BarCodeItemList,
      getboxwithcapacity,
      getExpiryDateStyle,
      getExpiryMessage,
    };
  },
});
</script>
<style>
.itemallocatefliter {
  display: flex;
  gap: 10px;
  align-items: center;

  li {
    width: max-content;
    padding: 7px 10px;
    border: 1px solid #999999;
    color: #999999;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    outline: none;
    transition: background-color 0.3s ease;
    box-sizing: border-box;
  }

  .active {
    color: #ffffff;
    outline: none;
    background: #3096ff;
    border: none;
    box-sizing: border-box;
  }
}

.DCItem {
  font-size: 14px;
  color: #ff5733;
}

.PromoItem {
  font-size: 14px;
  color: red;
}

.FreeItem {
  font-size: 14px;
  color: green;
}

.expiry-message {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
  font-style: italic;
}
</style>
